<template>
  <div class="MappingPartTypeTableComponent DataTables">
 
        <div :id="id"></div>

    </div>
</template>
<script>


  var $ = require('jquery');
  var jQuery = $
  window.$ = $
  window.jQuery = $
  var jquery = $;

  require("datatables.net");
  require("datatables.net-bs4");
  require("datatables.net-colreorder-bs4");
  require("datatables.net-select-bs4");
  require("datatables.net-keytable");
  require("datatables.net-buttons-bs4");


  import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'
  import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'
  import PartPropertiesType from '@/constants/PartPropertiesType'

  export default {
    name: "MappingPartTypeTableComponent",
    components: {

    },
    props:{
      lang: Object

    },
    data () {
      return {
        id: "MappingPartTypeTableComponent" + "_" + this._uid,
        mainTable: "",
        mappingFieldsInit: [
          {value: "partType", name: PartPropertiesType.PARTTYPE },
        ],
        mappingFields: [
        ],
        tableHeader: [],
        
      }
    },
    computed: {
      importedFileId(){
        return this.$store.getters.importedFileId
      }
    },
    created() {

      this.getProperties();

    },
    watch: {
      importedFileId: function(){

        this.getProperties();
      }

    },
        
    methods: {
      getProperties() {

        this.mappingFields = [];

        for (let i = 0, lei = this.mappingFieldsInit.length; i < lei; i++){

          this.mappingFields.push(this.mappingFieldsInit[i]);
        }

        

        let vue = this;
        
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_getPropertiesType")
        .then(function(result){

          for (let i = 0, lei = result.data.length; i < lei; i++){

            let obj = {
              value: result.data[i],
              name: result.data[i]
            }

              
              vue.mappingFields.push(obj);
            }

            vue.buildTable();

        })
      },
      buildTable(){

        let datatable = this.$store.getters.previewParts;

        this.$store.dispatch(this.$store.getters.sectionPrefix +"_resetMapField");
        var tableplace = document.getElementById(this.id);
  
        
        if (tableplace == null) {
          return
        }
        while (tableplace.firstChild) {
            tableplace.removeChild(tableplace.firstChild);
        }



        var place = document.createElement("table");
        place.setAttribute("id", "mappingplace"+this.name+"_"+this._uid);
        place.setAttribute("class", "table table-striped table-bordered");
        place.setAttribute("style", "width:100%;");
        tableplace.appendChild(place)

        var tr1 = document.createElement("tr");
        tr1.setAttribute("class", "cellHeader");
        var thead = document.createElement("thead");
        thead.appendChild(tr1);
        place.appendChild(thead);

        var tr2 = document.createElement("tr");
        tr2.setAttribute("class", "cellFooter");
        var tfoot = document.createElement("tfoot");
        tfoot.appendChild(tr2);
        place.appendChild(tfoot);

        var cols = [];

        var columnDefs = [];

        let columns = [];

        this.tableHeader = Object.keys(this.$store.getters.previewParts[0]);

        for (let i = 0, lei = this.tableHeader.length; i < lei; i++){
          let obj = {
            name: this.tableHeader[i],
            alignInColumn: "left",

          }

          columns.push(obj);
        }



        for (var i = 0, len = columns.length; i < len; i++){


          let el = {
            targets: i,
            className: '_dt-body-'+ columns[i].alignInColumn,
            render: function ( data, type, row, meta ) {
              if (data == null) {
                data = "";
              }

              data = $.fn.dataTable.render.text().display(data);
              if (data.display != undefined) {
                data.display = $.fn.dataTable.render.text().display(data.display);
              }

                return data

            },

            "data": null,

          }

          columnDefs.push(el);

          var obj = {"data": columns[i].name}
          cols.push(obj);

          var th1 = document.createElement("th");
          var th2 = document.createElement("th");
          tr1.appendChild(th1);
          tr2.appendChild(th2);

          var tx = document.createTextNode(columns[i].name)
          th1.appendChild(tx);



        }


        let datatable2 = [];
        for(var i = 0; i< datatable.length;++i){
          if (i == 0){
            datatable2.push(datatable[i]);
            datatable2.push(datatable[i]);
          }else{
            datatable2.push(datatable[i]);
          }

        }

        let first = datatable2[0]
        let firstArr = [];
        for(let prop in first){
          let obj = {
                columnName: prop,
                matched: false
              }
          firstArr.push(obj);
        }


        let f = {}
        for (const property in first) {
            f[property] = property;
        }
        datatable2[0] = f

        var json = {};
        json.data= datatable2;
        json.myColumnFormats = columns;
        json.lengthMenu = [25];
        json.select = false;
        json.columns = cols;
        json.ordering = false;
        json.columnDefs = columnDefs;
        json.paging = false;
        json.dom = '<<t>>';

        json.rowCallback = function( row, data, index ) {

            if ( index == 0 )
            {
                $('td', row).css('background-color', '#ccc');
                $('td', row).css('color', '#333');
                $('td', row).css('font-weight', '700');
            }

        }

        var vue = this;


        json.initComplete = function () {

              this.api().columns().every( function () {

                  var column = this;

                  var select = $('<select class="selectMapping"><option value=""></option></select>')
                      .appendTo( $(column.header()).empty() )
                      .on( 'change', function () {


                        let partType = $(this).val();
                        let columnName = vue.tableHeader[column[0][0]];

                        
                        let obj = {
                          
                          columnName: columnName,
                          operationType: partType

                        }
                        
                        vue.$store.dispatch(vue.$store.getters.sectionPrefix +"_addMapFieldPartType", obj);


                      } );

                  column.each( function ( d, j ) {

                    for (var i = 0, lei = vue.mappingFields.length; i < lei; i++){
                        
                                                
                        select.append( "<option value=\""+vue.mappingFields[i].value+"\" >" + vue.mappingFields[i].name+"</option>" )
                      
                      
                    }


                  } );
              } );
            }



            if ($.fn.dataTable.isDataTable('#mappingplace'+this.name+"_"+this._uid)) {
                this.mainTable.destroy();

            }

            this.mainTable = $('#mappingplace'+this.name+"_"+this._uid).DataTable(json);
            this.mainTable.columns.adjust().draw();


      }
    }


  }
</script>
<style lang="scss">

  .MappingPartTypeTableComponent{

    .selectMapping{
      width: 100%;
    }

    table{
      width: 100%;
      font-size: 0.75rem;

    }

    table th {
      padding: 2px !important;

    }
    .table thead th {
        vertical-align:top;
        border-bottom: 3px solid;
    }
    table td {
      padding: 2px !important;

    }
    .progress{
      width: 200px;

    }
    .dataTables_filter{
    float: left;
    font-size: 10px;
    }

    .dt-buttons{
      float: left;

      margin-left: 100px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .dt-button-collection{

      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;

    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }

    .cellHeader th{
      min-width: 100px;
    }

  }

  .blackIcon{
    background: #333;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/MappingPartTypeTableComponent.vue